import styled from "styled-components";

const Page = styled.div`
  background-color: ${props => props.theme.palette.grey["100"]};
  padding: 2em;
  flex-grow: 1;

  @media (max-width: 600px) {
    padding: 1em;
  }
`;

export default Page;
